import { Controller } from "@hotwired/stimulus"

// Gates the "Tear Down" submit button behind typed confirmation of
// the ImportRun's name. The submit button is disabled until the
// input's value exactly matches (case-sensitive) the `expectedName`
// value provided by the view. Server-side validation in
// `TeardownImportRun` re-checks the match so this controller is a
// UX gate only, not a security boundary.
//
// DOM contract (see `_teardown_confirm.html.erb`):
//   data-controller="import-teardown-confirm"
//   data-import-teardown-confirm-expected-name-value="<run name>"
//   data-import-teardown-confirm-target="input"
//   data-import-teardown-confirm-target="submit"
//   data-action="input->import-teardown-confirm#validate"
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = {
    expectedName: String,
  }

  declare readonly inputTarget: HTMLInputElement
  declare readonly submitTarget: HTMLButtonElement
  declare readonly expectedNameValue: string

  connect() {
    this.syncSubmit()
  }

  validate() {
    this.syncSubmit()
  }

  private syncSubmit() {
    if (!this.hasSubmitTarget) return
    const value = this.hasInputTarget ? this.inputTarget.value : ""
    this.submitTarget.disabled = value !== this.expectedNameValue
  }
}
